const BASE_URL = process.env.REACT_APP_API_URL;

export async function submitFeedback(payload) {
  const res = await fetch(`${BASE_URL}/feedback/submit/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Failed to submit");
  }
  return res.json();
}
